import { IXhrConfig } from './IHlsJsExtended';

/**
 * Applies our custom IXhrConfig declarative configuration to an XHR instance. May be used to adapt the config through the standard hls.js xhrSetup.
 * @param xhr
 * @param xhrConfig
 */
export function xhrSetupFromConfig(xhr: XMLHttpRequest, xhrConfig: IXhrConfig): void {
	if (!xhrConfig) {
		return;
	}

	if (xhrConfig.mimeType) {
		xhr.overrideMimeType(xhrConfig.mimeType);
	}

	xhr.withCredentials = !!xhrConfig.withCredentials;

	Object.entries(xhrConfig.additionalHeaders || {})
		.forEach(([key, value]) => xhr.setRequestHeader(key, '' + value));
}
